"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";

export function MainNav({}) {
  return (
    <Block className={"nav"} tag={"div"}>
      <Block className={"nav-left"} tag={"div"}>
        <Image
          className={"vectors-wrapper-7"}
          height={"34.99755859375"}
          loading={"lazy"}
          src={
            "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656ce0fa2da4744f69f8eadb_Vectors-Wrapper.svg"
          }
          width={"201.72203063964844"}
        />
      </Block>
      <Block className={"nav-center"} tag={"div"}>
        <Block className={"residents"} tag={"div"}>
          <Link
            button={false}
            className={"nav-link"}
            options={{
              href: "#",
            }}
          >
            {"Residents"}
          </Link>
        </Block>
        <Block className={" residents"} tag={"div"}>
          <Link
            button={false}
            className={"nav-link"}
            options={{
              href: "#",
            }}
          >
            {"Applicants"}
          </Link>
        </Block>
        <Block className={" residents"} tag={"div"}>
          <Link
            button={false}
            className={"nav-link"}
            options={{
              href: "#",
            }}
          >
            {"Careers"}
          </Link>
        </Block>
        <Block className={" residents"} tag={"div"}>
          <Link
            button={false}
            className={"nav-link"}
            options={{
              href: "#",
            }}
          >
            {"Contact"}
          </Link>
        </Block>
      </Block>
      <Block className={"nav-right"} tag={"div"}>
        <Link
          button={true}
          className={"button-navigation"}
          options={{
            href: "#",
          }}
        >
          {"Find Your Home"}
        </Link>
      </Block>
    </Block>
  );
}
